import { render, staticRenderFns } from "./AppWebSettingsList.vue?vue&type=template&id=403b6b9a"
import script from "./AppWebSettingsList.vue?vue&type=script&lang=js"
export * from "./AppWebSettingsList.vue?vue&type=script&lang=js"
import style0 from "./AppWebSettingsList.vue?vue&type=style&index=0&id=403b6b9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports